<template>
  <div class="wrapper">
    <el-card class="box-card" >
      <div class="text"  v-for="(card,index) in luckyDrawConditionEntities">
        <div slot="header" class="clearfix titleCon">
          <div class="titleName">条件 {{index+1}}</div>
          <div class="btn-list" v-if="!readonly">
            <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
            <el-button v-if="luckyDrawConditionEntities.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-list">
          <el-select :disabled="readonly" v-model="card.type">
            <el-option  v-for="(value,key) in typeList" :label="value" :value="key"></el-option>
          </el-select>
          <span v-if="card.type == 3 || card.type == 4">达到</span>
          <span v-if="card.type == 5">为</span>
          <el-input-number v-if="card.type == 3 || card.type == 4" v-model="card.typeValue" :disabled="readonly" ></el-input-number>
          <el-select v-if="card.type == 5" :disabled="readonly"  multiple   v-model="card.conditionsProductType">
            <el-option  v-for="(value,key) in zoneList" :label="value" :value="key"></el-option>
          </el-select>
          <el-select v-if="card.type == 5" :disabled="readonly" multiple    v-model="card.typeValue">
            <el-option  v-for="(value,key) in symbolList(card.conditionsProductType)" :label="value" :value="key"></el-option>
          </el-select>
          <span v-if="card.type == 3">美元</span>
          <span v-if="card.type == 4">手</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  require('@/views/crs36/luckyDraw/template.css')
  export default {
    name: 'condition',
    props:["update","luckyDrawConditionEntities","productionList"],
    methods: {
        addReward(){
            this.luckyDrawConditionEntities.push({"type":"","typeValue":0,"conditionsProductType":""});
        },
        delReward(index){
            this.luckyDrawConditionEntities.splice(index, 1);
        },
        symbolList(zoneArr){
          let symbolArr = {};
          if (zoneArr.length == 0) return symbolArr;
          for (let i in this.productionList) {
            if (zoneArr.indexOf(this.productionList[i].zone) >= 0) symbolArr[this.productionList[i].symbol] = this.productionList[i].name;
          }
          return symbolArr;
      }
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.isBy == 1)?true:false;
        },
        zoneList(){
          let zoneArr = {};
          for (let i in this.productionList) {
            zoneArr[this.productionList[i].zone] = this.productionList[i].zoneName;
          }
          return zoneArr;
        },
    },
    data () {
      return {
          typeList:{"3":"净入金","4":"交易手数","5":"交易产品","6":"激活"},
      }
    }
  }
</script>
